// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter-Thin";
  src: url('Inter_18pt-Thin.b672c892078838cf.ttf') format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ThinItalic";
  src: url('Inter_18pt-ThinItalic.1ae4bbff2a174f3e.ttf') format("truetype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraLight";
  src: url('Inter_18pt-ExtraLight.e7f00fab860c20e6.ttf') format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraLightItalic";
  src: url('Inter_18pt-ExtraLightItalic.3c4ecd87cb63f318.ttf') format("truetype");
  font-weight: 200;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Light";
  src: url('Inter_18pt-Light.1ae2e9095dce1837.ttf') format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Inter-LightItalic";
  src: url('Inter_18pt-LightItalic.86ecb2ee6740db4d.ttf') format("truetype");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Regular";
  src: url('Inter_18pt-Regular.a1db723976e507d7.ttf') format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter-Italic";
  src: url('Inter_18pt-Italic.6dbda78c20466a2c.ttf') format("truetype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Medium";
  src: url('Inter_18pt-Medium.adc5e93683f5a2c6.ttf') format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter-MediumItalic";
  src: url('Inter_18pt-MediumItalic.6ec291e61d343ee3.ttf') format("truetype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Inter-SemiBold";
  src: url('Inter_18pt-SemiBold.3558e0041c416c73.ttf') format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter-SemiBoldItalic";
  src: url('Inter_18pt-SemiBoldItalic.8d88e22b093702f6.ttf') format("truetype");
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Bold";
  src: url('Inter_18pt-Bold.658d907c4ee7ec52.ttf') format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BoldItalic";
  src: url('Inter_18pt-BoldItalic.b7f33d3f3e49aa99.ttf') format("truetype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraBold";
  src: url('Inter_18pt-ExtraBold.0b5fdb675ee3450e.ttf') format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraBoldItalic";
  src: url('Inter_18pt-ExtraBoldItalic.2b62d6c681eb6e70.ttf') format("truetype");
  font-weight: 800;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Black";
  src: url('Inter_18pt-Black.71a1a7d203392b4d.ttf') format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BlackItalic";
  src: url('Inter_18pt-BlackItalic.5a63eff995d4d6ea.ttf') format("truetype");
  font-weight: 900;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Thin";
  src: url('Inter_24pt-Thin.58643f7d18e5ee80.ttf') format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ThinItalic";
  src: url('Inter_24pt-ThinItalic.7738c73c19df3a2c.ttf') format("truetype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraLight";
  src: url('Inter_24pt-ExtraLight.1b68fb577474540f.ttf') format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraLightItalic";
  src: url('Inter_24pt-ExtraLightItalic.53043fb54f7591b9.ttf') format("truetype");
  font-weight: 200;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Light";
  src: url('Inter_24pt-Light.7ca59b69c5914209.ttf') format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Inter-LightItalic";
  src: url('Inter_24pt-LightItalic.9a6885576bb341a3.ttf') format("truetype");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Regular";
  src: url('Inter_24pt-Regular.37089f52ccd73e0c.ttf') format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter-Italic";
  src: url('Inter_24pt-Italic.1f14f2dbaaf71f56.ttf') format("truetype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Medium";
  src: url('Inter_24pt-Medium.f53ddc1e29b5dc42.ttf') format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter-MediumItalic";
  src: url('Inter_24pt-MediumItalic.c1cb22eb9229b30f.ttf') format("truetype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Inter-SemiBold";
  src: url('Inter_24pt-SemiBold.11540fc693bd1a25.ttf') format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter-SemiBoldItalic";
  src: url('Inter_24pt-SemiBoldItalic.9fc32b3c73f592dd.ttf') format("truetype");
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Bold";
  src: url('Inter_24pt-Bold.5b8409335a5b011c.ttf') format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BoldItalic";
  src: url('Inter_24pt-BoldItalic.05cccf4106bf8c7a.ttf') format("truetype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraBold";
  src: url('Inter_24pt-ExtraBold.560c123d023f024e.ttf') format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraBoldItalic";
  src: url('Inter_24pt-ExtraBoldItalic.23ce41a476f7b99d.ttf') format("truetype");
  font-weight: 800;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Black";
  src: url('Inter_24pt-Black.c728d810f68f4658.ttf') format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BlackItalic";
  src: url('Inter_24pt-BlackItalic.94873b88eaf949c5.ttf') format("truetype");
  font-weight: 900;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Thin";
  src: url('Inter_28pt-Thin.05d442300d8d6ed2.ttf') format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ThinItalic";
  src: url('Inter_28pt-ThinItalic.1a8213b684ad8909.ttf') format("truetype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraLight";
  src: url('Inter_28pt-ExtraLight.99fe1bd1f90a37e1.ttf') format("truetype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraLightItalic";
  src: url('Inter_28pt-ExtraLightItalic.800475aed3476553.ttf') format("truetype");
  font-weight: 200;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Light";
  src: url('Inter_28pt-Light.f163dafce5b06c37.ttf') format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Inter-LightItalic";
  src: url('Inter_28pt-LightItalic.2dfb9ead2978964f.ttf') format("truetype");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Regular";
  src: url('Inter_28pt-Regular.c68fb64554fd6a19.ttf') format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter-Italic";
  src: url('Inter_28pt-Italic.01686dbb92dd9e49.ttf') format("truetype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Medium";
  src: url('Inter_28pt-Medium.e18063f93e46eb22.ttf') format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter-MediumItalic";
  src: url('Inter_28pt-MediumItalic.232ec9294fed3db4.ttf') format("truetype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Inter-SemiBold";
  src: url('Inter_28pt-SemiBold.08982272863dd7a9.ttf') format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter-SemiBoldItalic";
  src: url('Inter_28pt-SemiBoldItalic.cbbadc1033dd68ec.ttf') format("truetype");
  font-weight: 600;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Bold";
  src: url('Inter_28pt-Bold.9616bbcdcb86392d.ttf') format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BoldItalic";
  src: url('Inter_28pt-BoldItalic.a4cb7f03305d043a.ttf') format("truetype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Inter-ExtraBold";
  src: url('Inter_28pt-ExtraBold.0b475c990bfaa78b.ttf') format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Inter-ExtraBoldItalic";
  src: url('Inter_28pt-ExtraBoldItalic.439434e69fb4dc52.ttf') format("truetype");
  font-weight: 800;
  font-style: italic;
}
@font-face {
  font-family: "Inter-Black";
  src: url('Inter_28pt-Black.de58bb46650e6f06.ttf') format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Inter-BlackItalic";
  src: url('Inter_28pt-BlackItalic.e8a6f34124a6c4a5.ttf') format("truetype");
  font-weight: 900;
  font-style: italic;
}
body {
  font-family: "Inter";
  font-weight: 400;
  font-style: normal;
}

.nav-link {
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 8px;
}
.nav-link.collapsed {
  justify-content: center;
}
.nav-link .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  transition: all 0.3s ease;
}
.nav-link .icon-color {
  color: #f97316;
}
.nav-link .caption-color {
  color: #7323A8;
  transition: all 0.3s ease;
}
.nav-link:hover:not(.active) {
  background-color: #8E008B;
}
.nav-link:hover:not(.active) .icon-color,
.nav-link:hover:not(.active) .caption-color {
  color: #f97316;
}
.nav-link.active {
  background-color: #8E008B;
}
.nav-link.active .icon-color {
  color: #FFFFFF;
}
.nav-link.active .caption-color {
  color: #f97316;
}`, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/styles/fonts/Inter/_fonts.scss","webpack://./libs/ui/src/lib/components/units/zikata-menu-item/zikata-menu-item.component.scss","webpack://./libs/ui/src/lib/styles/_globalVariables.scss"],"names":[],"mappings":"AAqBA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;ACpBJ;ADuBA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACrBJ;ADwBA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACtBJ;ADyBA;EACI,qCAAA;EACA,+EAAA;EACA,gBAAA;EACA,kBAAA;ACvBJ;AD0BA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;ACxBJ;AD2BA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;ACzBJ;AD4BA;EACI,4BAAA;EACA,sEAAA;EACA,gBAAA;EACA,kBAAA;AC1BJ;AD6BA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AC3BJ;AD8BA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AC5BJ;AD+BA;EACI,iCAAA;EACA,2EAAA;EACA,gBAAA;EACA,kBAAA;AC7BJ;ADgCA;EACI,6BAAA;EACA,uEAAA;EACA,gBAAA;EACA,kBAAA;AC9BJ;ADiCA;EACI,mCAAA;EACA,6EAAA;EACA,gBAAA;EACA,kBAAA;AC/BJ;ADkCA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;AChCJ;ADmCA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACjCJ;ADoCA;EACI,8BAAA;EACA,wEAAA;EACA,gBAAA;EACA,kBAAA;AClCJ;ADqCA;EACI,oCAAA;EACA,8EAAA;EACA,gBAAA;EACA,kBAAA;ACnCJ;ADsCA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;ACpCJ;ADuCA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;ACrCJ;ADwCA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;ACtCJ;ADyCA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACvCJ;AD0CA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACxCJ;AD2CA;EACI,qCAAA;EACA,+EAAA;EACA,gBAAA;EACA,kBAAA;ACzCJ;AD4CA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;AC1CJ;AD6CA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;AC3CJ;AD8CA;EACI,4BAAA;EACA,sEAAA;EACA,gBAAA;EACA,kBAAA;AC5CJ;AD+CA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AC7CJ;ADgDA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AC9CJ;ADiDA;EACI,iCAAA;EACA,2EAAA;EACA,gBAAA;EACA,kBAAA;AC/CJ;ADkDA;EACI,6BAAA;EACA,uEAAA;EACA,gBAAA;EACA,kBAAA;AChDJ;ADmDA;EACI,mCAAA;EACA,6EAAA;EACA,gBAAA;EACA,kBAAA;ACjDJ;ADoDA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;AClDJ;ADqDA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACnDJ;ADsDA;EACI,8BAAA;EACA,wEAAA;EACA,gBAAA;EACA,kBAAA;ACpDJ;ADuDA;EACI,oCAAA;EACA,8EAAA;EACA,gBAAA;EACA,kBAAA;ACrDJ;ADwDA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;ACtDJ;ADyDA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;ACvDJ;AD0DA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;ACxDJ;AD2DA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACzDJ;AD4DA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;AC1DJ;AD6DA;EACI,qCAAA;EACA,+EAAA;EACA,gBAAA;EACA,kBAAA;AC3DJ;AD8DA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;AC5DJ;AD+DA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;AC7DJ;ADgEA;EACI,4BAAA;EACA,sEAAA;EACA,gBAAA;EACA,kBAAA;AC9DJ;ADiEA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AC/DJ;ADkEA;EACI,2BAAA;EACA,qEAAA;EACA,gBAAA;EACA,kBAAA;AChEJ;ADmEA;EACI,iCAAA;EACA,2EAAA;EACA,gBAAA;EACA,kBAAA;ACjEJ;ADoEA;EACI,6BAAA;EACA,uEAAA;EACA,gBAAA;EACA,kBAAA;AClEJ;ADqEA;EACI,mCAAA;EACA,6EAAA;EACA,gBAAA;EACA,kBAAA;ACnEJ;ADsEA;EACI,yBAAA;EACA,mEAAA;EACA,gBAAA;EACA,kBAAA;ACpEJ;ADuEA;EACI,+BAAA;EACA,yEAAA;EACA,gBAAA;EACA,kBAAA;ACrEJ;ADwEA;EACI,8BAAA;EACA,wEAAA;EACA,gBAAA;EACA,kBAAA;ACtEJ;ADyEA;EACI,oCAAA;EACA,8EAAA;EACA,gBAAA;EACA,kBAAA;ACvEJ;AD0EA;EACI,0BAAA;EACA,oEAAA;EACA,gBAAA;EACA,kBAAA;ACxEJ;AD2EA;EACI,gCAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;ACzEJ;ADiGA;EANE,oBAAA;EACA,gBAVoB;EAWpB,kBAHqC;ACrFvC;;AAtUA;EACE,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAyUF;AAvUE;EACE,uBAAA;AAyUJ;AAtUE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAwUJ;AArUE;EACE,cAAA;AAuUJ;AApUE;EACE,cCpBY;EDqBZ,yBAAA;AAsUJ;AAnUE;EACE,yBCrBU;AD0Vd;AAnUI;;EAEE,cAAA;AAqUN;AAjUE;EACE,yBC9BU;ADiWd;AAjUI;EACE,cCnBS;ADsVf;AAhUI;EACE,cAAA;AAkUN","sourcesContent":["// Font family variables\n$font-family-inter-thin: 'Inter-Thin';\n$font-family-inter-thin-italic: 'Inter-ThinItalic';\n$font-family-inter-extra-light: 'Inter-ExtraLight';\n$font-family-inter-extra-light-italic: 'Inter-ExtraLightItalic';\n$font-family-inter-light: 'Inter-Light';\n$font-family-inter-light-italic: 'Inter-LightItalic';\n$font-family-inter-regular: 'Inter-Regular';\n$font-family-inter-italic: 'Inter-Italic';\n$font-family-inter-medium: 'Inter-Medium';\n$font-family-inter-medium-italic: 'Inter-MediumItalic';\n$font-family-inter-semi-bold: 'Inter-SemiBold';\n$font-family-inter-semi-bold-italic: 'Inter-SemiBoldItalic';\n$font-family-inter-bold: 'Inter-Bold';\n$font-family-inter-bold-italic: 'Inter-BoldItalic';\n$font-family-inter-extra-bold: 'Inter-ExtraBold';\n$font-family-inter-extra-bold-italic: 'Inter-ExtraBoldItalic';\n$font-family-inter-black: 'Inter-Black';\n$font-family-inter-black-italic: 'Inter-BlackItalic';\n\n// Font-face declarations\n@font-face {\n    font-family: 'Inter-Thin';\n    src: url('static/Inter_18pt-Thin.ttf') format('truetype');\n    font-weight: 100;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ThinItalic';\n    src: url('static/Inter_18pt-ThinItalic.ttf') format('truetype');\n    font-weight: 100;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLight';\n    src: url('static/Inter_18pt-ExtraLight.ttf') format('truetype');\n    font-weight: 200;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLightItalic';\n    src: url('static/Inter_18pt-ExtraLightItalic.ttf') format('truetype');\n    font-weight: 200;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Light';\n    src: url('static/Inter_18pt-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-LightItalic';\n    src: url('static/Inter_18pt-LightItalic.ttf') format('truetype');\n    font-weight: 300;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Regular';\n    src: url('static/Inter_18pt-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-Italic';\n    src: url('static/Inter_18pt-Italic.ttf') format('truetype');\n    font-weight: 400;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Medium';\n    src: url('static/Inter_18pt-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-MediumItalic';\n    src: url('static/Inter_18pt-MediumItalic.ttf') format('truetype');\n    font-weight: 500;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBold';\n    src: url('static/Inter_18pt-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBoldItalic';\n    src: url('static/Inter_18pt-SemiBoldItalic.ttf') format('truetype');\n    font-weight: 600;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Bold';\n    src: url('static/Inter_18pt-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BoldItalic';\n    src: url('static/Inter_18pt-BoldItalic.ttf') format('truetype');\n    font-weight: 700;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBold';\n    src: url('static/Inter_18pt-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBoldItalic';\n    src: url('static/Inter_18pt-ExtraBoldItalic.ttf') format('truetype');\n    font-weight: 800;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Black';\n    src: url('static/Inter_18pt-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BlackItalic';\n    src: url('static/Inter_18pt-BlackItalic.ttf') format('truetype');\n    font-weight: 900;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Thin';\n    src: url('static/Inter_24pt-Thin.ttf') format('truetype');\n    font-weight: 100;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ThinItalic';\n    src: url('static/Inter_24pt-ThinItalic.ttf') format('truetype');\n    font-weight: 100;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLight';\n    src: url('static/Inter_24pt-ExtraLight.ttf') format('truetype');\n    font-weight: 200;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLightItalic';\n    src: url('static/Inter_24pt-ExtraLightItalic.ttf') format('truetype');\n    font-weight: 200;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Light';\n    src: url('static/Inter_24pt-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-LightItalic';\n    src: url('static/Inter_24pt-LightItalic.ttf') format('truetype');\n    font-weight: 300;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Regular';\n    src: url('static/Inter_24pt-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-Italic';\n    src: url('static/Inter_24pt-Italic.ttf') format('truetype');\n    font-weight: 400;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Medium';\n    src: url('static/Inter_24pt-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-MediumItalic';\n    src: url('static/Inter_24pt-MediumItalic.ttf') format('truetype');\n    font-weight: 500;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBold';\n    src: url('static/Inter_24pt-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBoldItalic';\n    src: url('static/Inter_24pt-SemiBoldItalic.ttf') format('truetype');\n    font-weight: 600;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Bold';\n    src: url('static/Inter_24pt-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BoldItalic';\n    src: url('static/Inter_24pt-BoldItalic.ttf') format('truetype');\n    font-weight: 700;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBold';\n    src: url('static/Inter_24pt-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBoldItalic';\n    src: url('static/Inter_24pt-ExtraBoldItalic.ttf') format('truetype');\n    font-weight: 800;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Black';\n    src: url('static/Inter_24pt-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BlackItalic';\n    src: url('static/Inter_24pt-BlackItalic.ttf') format('truetype');\n    font-weight: 900;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Thin';\n    src: url('static/Inter_28pt-Thin.ttf') format('truetype');\n    font-weight: 100;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ThinItalic';\n    src: url('static/Inter_28pt-ThinItalic.ttf') format('truetype');\n    font-weight: 100;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLight';\n    src: url('static/Inter_28pt-ExtraLight.ttf') format('truetype');\n    font-weight: 200;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraLightItalic';\n    src: url('static/Inter_28pt-ExtraLightItalic.ttf') format('truetype');\n    font-weight: 200;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Light';\n    src: url('static/Inter_28pt-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-LightItalic';\n    src: url('static/Inter_28pt-LightItalic.ttf') format('truetype');\n    font-weight: 300;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Regular';\n    src: url('static/Inter_28pt-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-Italic';\n    src: url('static/Inter_28pt-Italic.ttf') format('truetype');\n    font-weight: 400;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Medium';\n    src: url('static/Inter_28pt-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-MediumItalic';\n    src: url('static/Inter_28pt-MediumItalic.ttf') format('truetype');\n    font-weight: 500;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBold';\n    src: url('static/Inter_28pt-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-SemiBoldItalic';\n    src: url('static/Inter_28pt-SemiBoldItalic.ttf') format('truetype');\n    font-weight: 600;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Bold';\n    src: url('static/Inter_28pt-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BoldItalic';\n    src: url('static/Inter_28pt-BoldItalic.ttf') format('truetype');\n    font-weight: 700;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBold';\n    src: url('static/Inter_28pt-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-ExtraBoldItalic';\n    src: url('static/Inter_28pt-ExtraBoldItalic.ttf') format('truetype');\n    font-weight: 800;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Inter-Black';\n    src: url('static/Inter_28pt-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Inter-BlackItalic';\n    src: url('static/Inter_28pt-BlackItalic.ttf') format('truetype');\n    font-weight: 900;\n    font-style: italic;\n}\n\n\n// Font Variables\n$font-family-sans-serif: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n$font-weight-thin: 100;\n$font-weight-extra-light: 200;\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-semi-bold: 600;\n$font-weight-bold: 700;\n$font-weight-extra-bold: 800;\n$font-weight-black: 900;\n\n// Mixin for Font Faces\n@mixin font-face($weight: 400, $style: normal) {\n  font-family: 'Inter';\n  font-weight: $weight;\n  font-style: $style;\n}\n\n// Example usage of the mixin\nbody {\n  @include font-face($font-weight-regular);\n}\n","@import \"../../../styles/globalVariables\";\n\n.nav-link {\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n\n  &.collapsed {\n    justify-content: center;\n  }\n\n  .icon-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    transition: all 0.3s ease;\n  }\n\n  .icon-color {\n    color: #f97316; // orange instead of pink\n  }\n\n  .caption-color {\n    color: $zikata-purple;\n    transition: all 0.3s ease;\n  }\n\n  &:hover:not(.active) {\n    background-color: $zikata-plum;\n\n    .icon-color,\n    .caption-color {\n      color: #f97316; // orange on hover\n    }\n  }\n\n  &.active {\n    background-color: $zikata-plum;\n\n    .icon-color {\n      color: $zikata-white;\n    }\n\n    .caption-color {\n      color: #f97316; // orange for active label\n    }\n  }\n}","@import \"../styles/fonts/Inter/fonts\";\n\n// Enable negative margins for Bootstrap\n$enable-negative-margins: true;\n\n// Primary Colors from Figma\n$zikata-purple-dark: #2E005D;\n$zikata-purple: #7323A8;\n$zikata-pink: #E50085;\n$zikata-coral: #FF5E5B;\n$zikata-orange: #FF6D00; \n$zikata-plum: #8E008B;\n$zikata-plum-dark: #6A007B;\n$zikata-peach-light: #FFE5DD;\n\n// Extended Color Palette\n$zikata-purple-light: lighten($zikata-purple, 30%);\n$zikata-pink-light: lighten($zikata-pink, 30%);\n$zikata-coral-light: lighten($zikata-coral, 30%);\n$zikata-orange-light: lighten($zikata-orange, 30%);\n\n// Zikata Monochrome Color Palette\n\n// Pure Black and White\n$zikata-black: #000000;\n$zikata-white: #FFFFFF;\n\n// Grays - from lightest to darkest\n$zikata-gray-100: #F8F8F8;\n$zikata-gray-200: #EFF1F3;\n$zikata-gray-300: #D9D9D9; // Solid version of gray-350\n$zikata-gray-350: #D9D9D966; // Semi-transparent gray (40% opacity)\n$zikata-gray-400: #D4D7D9;\n$zikata-gray-500: #6C757D;\n$zikata-gray-600: #2A3846;\n$zikata-gray-700: darken($zikata-gray-600, 5%);\n$zikata-gray-800: darken($zikata-gray-600, 10%);\n$zikata-gray-900: darken($zikata-gray-600, 15%);\n\n// RGBA versions for flexibility\n$zikata-gray-300-rgba: rgba(217, 217, 217, 1); // Equivalent to #D9D9D9\n$zikata-gray-350-rgba: rgba(217, 217, 217, 0.4); // Equivalent to #D9D9D966\n\n// Function to get rgba version of any color\n@function zikata-rgba($color, $opacity: 1) {\n  @return rgba($color, $opacity);\n}\n\n// Semantic Colors\n$zikata-primary: $zikata-purple;\n$zikata-secondary: $zikata-gray-300-rgba;\n$zikata-success: #0F996D;\n$zikata-info: $zikata-purple-light;\n$zikata-warning: $zikata-orange;\n$zikata-danger: $zikata-pink;\n$zikata-light: $zikata-gray-100;\n$zikata-magenta: #960093;\n$zikata-grape: #5C008B;\n$zikata-dark: $zikata-gray-900;\n\n// Body\n$zikata-body-bg: $zikata-gray-100;\n$zikata-body-color: $zikata-gray-900;\n\n// Links\n$zikata-link-color: $zikata-purple;\n$zikata-link-hover-color: darken($zikata-link-color, 15%);\n\n// Bootstrap Color System Override\n$theme-colors: (\n  \"primary\": $zikata-primary,\n  \"secondary\": $zikata-secondary,\n  \"success\": $zikata-success,\n  \"info\": $zikata-info,\n  \"warning\": $zikata-warning,\n  \"danger\": $zikata-danger,\n  \"light\": $zikata-light,\n  \"dark\": $zikata-dark\n);\n\n// Additional Custom Colors\n$custom-colors: (\n  \"purple-dark\": $zikata-purple-dark,\n  \"purple-light\": $zikata-purple-light,\n  \"pink\": $zikata-pink,\n  \"pink-light\": $zikata-pink-light,\n  \"coral\": $zikata-coral,\n  \"coral-light\": $zikata-coral-light,\n  \"orange\": $zikata-orange,\n  \"orange-light\": $zikata-orange-light,\n  \"plum\": $zikata-plum, \n  \"plum-dark\": $zikata-plum-dark, \n  \"peach-light\": $zikata-peach-light, \n  \"header-gray\": $zikata-gray-350-rgba, \n  \"magenta\": $zikata-magenta, \n  \"grape\": $zikata-grape, \n);\n\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      $font-family-sans-serif;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\n// Font Weights from fonts.scss\n$font-weight-thin:            $font-weight-thin;\n$font-weight-extra-light:     $font-weight-extra-light;\n$font-weight-light:           $font-weight-light;\n$font-weight-normal:          $font-weight-regular;\n$font-weight-medium:          $font-weight-medium;\n$font-weight-semibold:        $font-weight-semi-bold;\n$font-weight-bold:            $font-weight-bold;\n$font-weight-extra-bold:      $font-weight-extra-bold;\n$font-weight-black:           $font-weight-black;\n$font-weight-lighter:         lighter;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n\n// Merge theme-colors with custom-colors\n$theme-colors: map-merge($theme-colors, $custom-colors);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
